export enum BreadcrumbThumbnailType {
  None = 'none',
  Logo = 'logo',
  Icon = 'icon',
  Image = 'image',
}
